import React, { FC } from 'react';
import Box from '@mui/material/Box';
import { Link } from '@mui/material';
import { PatternFormat } from 'react-number-format';
import { parseNumber } from '../../../helpers/ValidatorHelper';
import { StringCellValue } from '../../UI/MfResponsiveTable/MfResponsiveTable';

interface Props {
  phone: string | undefined;
}

const PhoneCell: FC<Props> = ({ phone }) => (
  <StringCellValue>
    <Box sx={{ whiteSpace: 'nowrap' }}>
      <Link href={`tel:+7${parseNumber(phone || '')}`}>
        +7{' '}
        <PatternFormat
          value={phone}
          format="(###) ###-##-##"
          displayType="text"
        />
      </Link>
    </Box>
  </StringCellValue>
);

export default PhoneCell;
